module.exports = __webpack_public_path__ + "static/media/logo_banner.573d7cf7.png";